'use client'

import { useCompanyContext } from '@/app/context/CompanyContext'
import { companyAllowsMutations } from '@/utils/company-readonly-ui.util'

/** True when COMPANY_READONLY is effective for the loaded company. */
export function useIsCompanyReadonly(): boolean {
    const { isCompanyReadonly } = useCompanyContext()
    return isCompanyReadonly === true
}

export function useCompanyAllowsMutations(): boolean {
    const readonly = useIsCompanyReadonly()
    return companyAllowsMutations(readonly)
}
